import { render, staticRenderFns } from "./reservation-bills.vue?vue&type=template&id=129cca36&scoped=true&"
import script from "./reservation-bills.vue?vue&type=script&lang=js&"
export * from "./reservation-bills.vue?vue&type=script&lang=js&"
import style0 from "./reservation-bills.vue?vue&type=style&index=0&id=129cca36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129cca36",
  null
  
)

export default component.exports